<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" size="small">
            <el-row>
                <el-form-item :label="$d('原始密码')" required>
                    <el-input v-model="form.password" show-word-limit maxlength="50" show-password></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$d('新密码')" required>
                    <el-input v-model="form.newPassword" show-word-limit maxlength="50" show-password
                              :placeholder="$d('含大小写、数字、特殊字符，长度至少8位')"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$d('重复新密码')" required>
                    <el-input v-model="form.repeatNewPassword" show-word-limit maxlength="50" show-password
                              :placeholder="$d('含大小写、数字、特殊字符，长度至少8位')"></el-input>
                </el-form-item>
            </el-row>
        </el-form>

    </div>
</template>

<script>

export default {
    name: 'edit-password',
    title: '修改密码',
    props: {},
    components: {},
    methods: {
        submitForm () {
            if (this.form.password === '') {
                this.etao.message.toast(this.$d('原始密码不能为空'), 'error')
                return
            }
            if (this.form.newPassword === '') {
                this.etao.message.toast(this.$d('新密码不能为空'), 'error')
                return
            }
            if (this.form.repeatNewPassword === '') {
                this.etao.message.toast(this.$d('重复新密码不能为空'), 'error')
                return
            }
            let password = this.form.password
            let newPassword = this.form.newPassword
            let repeatNewPassword = this.form.repeatNewPassword
            const isComplex = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}/.test(newPassword)
            if (!isComplex) {
                // 密码复杂度不足,至少包含大写字母、小写字母、数字，且长度至少8位
                this.etao.message.toast(this.$d('密码复杂度不足，至少包含大写字母、小写字母、数字、特殊字符，且长度至少8位'), 'error')
                return
            }
            if (newPassword !== repeatNewPassword) {
                this.etao.message.toast(this.$d('两次新密码不一致'), 'error')
                return
            }
            this.$confirm(this.$d('此操作不可逆,确定提交吗？'), this.$d('提示'), {
                confirmButtonText: this.$d('确定'),
                cancelButtonText: this.$d('取消'),
                type: 'warning'
            }).then(() => {
                this.etao.requests.post({
                    url: '/etao-system/user/update-password',
                    data: {
                        password: password,
                        newPassword: newPassword,
                        repeatNewPassword: repeatNewPassword
                    },
                    success: res => {
                        return this.etao.message.alert(res.msg, '提示', () => {
                            this.closeForm()
                            this.logout()
                        })
                    }
                })
            })
        },
        refreshForm () {
            this.$set(this, 'form', this.getDefaultForm())
        },
        beforeCloseForm () {
            if (this.form.status === 1) {
                this.etao.message.confirm(
                    this.$d('确认关闭表单，系统将会放弃未保存的数据'),
                    this.$d('关闭表单'),
                    () => this.closeForm()
                )
            } else {
                this.closeForm()
            }
        },
        closeForm () {
            this.$emit('close')
        },
        getDefaultForm () {
            return {
                password: '',
                newPassword: '',
                repeatNewPassword: ''
            }
        }
    },
    data () {
        return {
            form: this.getDefaultForm()
        }
    },
    mounted () {
        this.refreshForm()
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/index/edit-password.vue